import type { Option } from '@/components/ui/multi-select/useMultiSelect'

interface OptionListProps {
  id: string
  label: string
  options: Option[]
  selectedValues: string[]
  activeIndex: number
  optionId: (index: number) => string
  onToggle: (value: string) => void
  onHover: (index: number) => void
}

export function OptionList({
  id,
  label,
  options,
  selectedValues,
  activeIndex,
  optionId,
  onToggle,
  onHover,
}: OptionListProps) {
  return (
    <ul
      id={id}
      role="listbox"
      aria-multiselectable="true"
      aria-label={label}
      className="absolute z-50 mt-1 w-full max-h-60 overflow-auto rounded-md border border-theme-border bg-surface shadow-lg"
    >
      {options.length === 0 ? (
        <li className="px-3 py-2 text-sm text-muted">No results</li>
      ) : (
        options.map((option, index) => {
          const selected = selectedValues.includes(option.value)
          return (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events -- keyboard handled on the combobox input via aria-activedescendant (WAI-ARIA listbox pattern); options are intentionally not focusable
            <li
              key={option.value}
              id={optionId(index)}
              role="option"
              aria-selected={selected}
              onClick={() => onToggle(option.value)}
              onMouseEnter={() => onHover(index)}
              className={`px-3 py-1.5 text-sm cursor-pointer transition-colors text-primary ${
                index === activeIndex ? 'bg-active' : 'hover:bg-active'
              }`}
            >
              <span className="inline-block w-4 mr-1.5" aria-hidden="true">
                {selected ? '✓' : ''}
              </span>
              {option.label}
            </li>
          )
        })
      )}
    </ul>
  )
}
